import { render, staticRenderFns } from "./SubjectTable.vue?vue&type=template&id=3643357d&scoped=true&"
import script from "./SubjectTable.vue?vue&type=script&lang=js&"
export * from "./SubjectTable.vue?vue&type=script&lang=js&"
import style0 from "./SubjectTable.vue?vue&type=style&index=0&id=3643357d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643357d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
